import axios from 'axios';
import config from '../config/config';
import Swal from 'sweetalert2';

export const authService = {
    post,
    postWithToken
};
function post(apiEndpoint, payload) {
    return axios.post(config.baseUrl + apiEndpoint, payload, getOptions())
        .then((response) => {
            return response;
        }).catch((err) => {
            console.log(err);
        })
}
function postWithToken(apiEndpoint, payload, token) {

    return axios.post(config.baseUrl + apiEndpoint, payload, getOptions())
        .then((response) => {
            return response;
        }).catch((err) => {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Login inválido!'
            })
            return err;
        })
}
function getOptions() {
    let options = {};
 
    var token = localStorage.getItem('token');
    if (token === undefined || token === null) {
        token = 'gestorrp:gestor2414#';
    }
    let authdata = window.btoa(token);
    options.headers = { 'Authorization': 'Basic ' + authdata };
    return options;
}